export default __webpack_public_path__ + "static/media/Hotel.b8693a16.png";